import Content from "./modernbusinesses/Content";
import Stats from "./modernbusinesses/Stats";
import { motion } from "framer-motion";

export default function ModernBusinesses() {
  return (
    <div className="modernbusinesses-wrapper section">
      <motion.div
        className="modernbusinesses flex container"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <Content />
        <Stats />
      </motion.div>
    </div>
  );
}
